module.exports = __webpack_public_path__ + "static/media/wallpaper-6.4bbd01ab.jpg";